<template>
	<div :class="[getGroupClass]">
        <div class="grid-col grid-xsmall-12 grid-large-4">
            <label class="label" :for="id">{{label}}</label>
            <span :id="'input-ex-hint'+id" class="hint" v-if="hintText != ''">
                {{hintText}}
            </span>
            
            <span :id="'input-ex-error'+id" class="error-message" v-if="validate.$error">
                {{errorMessage}}
            </span>
        </div>
            <div class="grid-col grid-col--soft grid-xsmall-12 grid-large-8">
            <select
                v-model="m"
                :name="name"
                :id="id"
                :class="[getClass, {'select--error' : validate.$error}]">
                <option v-for="(option, index) in options" :key="index" :value="option.id">{{ answerLabels[index] }}</option>
            </select>
        </div>
	</div>
</template>

<script>
export default {
	name: 'TextInput',
	props: {
		id: {
			type: String,
			required: true,
			default: null
		},
		name: {
			type: String,
			required: true,
			default: null
		},
		label: {
			type: String,
			required: true,
			default: null
		},
		value: {
			type: String,
			default: ""
		},
		type: {
			type: String,
			default: "text"
		},
		validate: {
			type: Object,
			required: false
		},
		hintText: {
			type: String,
			default: null
		},
		errorMessage: {
			type: String,
			default: null
		},
        options: {
            type: Array
        },
        answerLabels: {
            type: Array
        }
	},
	data() {
		return {
			getGroupClass: "form-group",
			getClass: "select"
		}
	},
	computed: {
		m: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit("input", value);
			}
		}
	}
}
</script>